import { TableHeader } from "../../commons";
import RecurringJobReportTableData from "./RecurringJobReportTableData";
import { RECURRING_JOB_REPORT_CLIENT_HEADER, RECURRING_JOBS_REPORT_TABLE_HEADER } from "../../../constant/tableHeadersConstants/Jobs/recurringJobReportTableHeader";
import { RecurringJobReportListType } from "../../../redux/jobs/jobsType";

type AppProps = {
  data: RecurringJobReportListType[] | [];
  setData:any;
  recurringJobReportList:RecurringJobReportListType[]|[];
  handleRedirectToRecurringJobSetting:(data:any)=>void;
};

const RecurringJobReportTable = ({
  data,
  recurringJobReportList,
  setData,
  handleRedirectToRecurringJobSetting
}: AppProps) => {
  return (
    <div>
    <div className="jobsType" style={{minHeight:"400px"}}>
      <table className="table">
       
        <tbody>
          <RecurringJobReportTableData
            data={data}
            setData={setData}
            tableHeader={RECURRING_JOB_REPORT_CLIENT_HEADER}
            handleRedirectToRecurringJobSetting={handleRedirectToRecurringJobSetting}
          />
        </tbody>
      </table>
    </div>
  </div>
  );
};

export default RecurringJobReportTable;

